/**
 * Course applicatoin form JS.
 */
$(document).ready(() => {
  const regionId = $('[name="region_id"]').val();
  const $regionSelect = $('#region_id');
  const $schoolTypeSelect = $('#school_form');
  const $schoolGradeTypeSelect = $('#student_class_id');

  if ($regionSelect.length) {
    $regionSelect.change(e => {
      const regionID = $(e.target).val();
      updateSelectBoxes(regionID);
    });
  } else if (regionId) {
    updateSelectBoxes(regionId);
  }

  function updateSelectBoxes(regionID) {
    const region = FORM_DATA.regions[regionID];
    console.log('update select', regionID, region);
    // Populate school type select.
    populateSelect($schoolTypeSelect, region.schoolTypes);
    // Populate school grade type select.
    populateSelect($schoolGradeTypeSelect, region.schoolGradeTypes);
    // Enable selects.
    $schoolTypeSelect.attr('disabled', false);
    $schoolGradeTypeSelect.attr('disabled', false);
  }

  function populateSelect($element, options) {
    const newOptions = $.map(options, (item, index) => {
      return `<option value="${item.id}">${item.type}</option>`;
    });

    $element.find('[value="-"]')
        .nextAll()
        .remove();
    $element.append(newOptions);
  }
});
